import axios from "./axios";

export class FmsyncModel {
  addOnceOffDonations(donations) {
    return axios.get("api/donor_list");
  }

  getSupportList(filter) {
    return axios.get("api/lists" + (filter || ""));
  }

  donate(data, config) {
    return axios.post("api/donate", data, config);
  }

  reciept(token) {
    return {}; // fetchGet(`${this.api_url}/receipt?token=${encodeURIComponent(token)}`);
  }
}

const Fmsync = new FmsyncModel();

export default Fmsync;
